import './bootstrap';
import "../css/app.css";
import { route } from "./stores/route";

// Triggers on Route change
history.pushState = new Proxy(history.pushState, {
    apply(target, thisArg, argumentList) {
        Reflect.apply(target, thisArg, argumentList);
        onRouteChanged();
    },
});

// Triggers on Route change
addEventListener("popstate", function (e) {
    onRouteChanged();
});

const onRouteChanged = async () => {
    route.set(window.location);
    scrollTo(0, 0);
};

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

window.addEventListener('resize', appHeight)

appHeight()

// Function to convert the colors object into CSS variables
function generateCSSVariables(colors) {
    let css = ":root {\n";
    for (let [colorGroup, colorValues] of Object.entries(colors)) {
        for (let [key, value] of Object.entries(colorValues)) {
            css += `    --${colorGroup.toLowerCase()}-${key}: ${value.replaceAll(',', '')};\n`;
        }
    }
    css += "}\n";
    return css;
}

// Generate the CSS
const css = generateCSSVariables(window.meta.colors);

// Create a <style> element
const style = document.createElement('style');
style.textContent = css;

// Append the <style> element to the body
document.head.appendChild(style);